// className
var MANHATTAN_SKELETON = 'manhattan-skeleton';
var MANHATTAN_SKELETON_IMG = 'manhattan-skeleton_img';
var MANHATTAN_SKELETON_EL = 'manhattan-skeleton_el';
var SKELETON_ELEMENT_NOANIMATION = 'manhattan-skeleton_el--noanimation';
var getAvailableClassName = function () {
    var ua = window.navigator.userAgent.toLowerCase();
    if (/android/i.test(ua)) {
        // 取安卓版本号
        var version = ua.match(/android [\d._]+/gi) && ua.match(/android [\d._]+/gi)[0];
        var androidCode = version && version.split(' ')[1].split('.')[0];
        if (androidCode && parseInt(androidCode, 10) < 5) {
            return SKELETON_ELEMENT_NOANIMATION;
        }
        return MANHATTAN_SKELETON_EL;
    }
    // 特殊 Chrome 版本-_-
    if (ua.includes('chrome/34.0.1847.116')) {
        return SKELETON_ELEMENT_NOANIMATION;
    }
    return MANHATTAN_SKELETON_EL;
};
var availableClass = getAvailableClassName();
// 判断 tagname
var isTag = function (el, name) {
    return el.tagName.toLocaleLowerCase() === name;
};
// 选出图片
var selectImgNode = function (nodes) {
    if (!nodes)
        return;
    if (!nodes.length)
        return;
    return nodes.filter(function (node) { return isTag(node, 'img'); });
};
// 处理图片
var replaceImgToSvg = function (el) {
    if (!isTag(el, 'img'))
        return;
    var originSrc = el.getAttribute('src');
    if (originSrc)
        el.dataset.originSrc = originSrc;
    el.setAttribute('src', window._vskeleton_default_img);
};
// 恢复图片
var replaceSvgToImg = function (el) {
    if (!isTag(el, 'img'))
        return;
    var originSrc = el.dataset['originSrc'];
    if (originSrc) {
        el.setAttribute('src', originSrc);
        delete el.dataset['originSrc'];
    }
};
// 处理 button 元素
var skeepButton = function (el) {
    if (isTag(el, 'button'))
        return;
    var parents = [];
    var parent = el.parentNode;
    while (parent) {
        if (parent.nodeName.toLocaleLowerCase() === 'body')
            break;
        parents.push(parent);
        parent = parent.parentNode;
    }
    // 判断字节是不是有 button 的祖先节点
    if (parents.map(function (parent) { return parent.tagName.toLocaleLowerCase(); }).includes('button')) {
        return true;
    }
    return false;
};
// 遍历所有 dom
function getChildren(parent) {
    // 获取NodeIterator对象
    var tree = document.createTreeWalker(parent, NodeFilter.SHOW_ELEMENT);
    // 获取所有子节点
    var currentNode;
    var children = [];
    currentNode = tree.nextNode();
    while (currentNode) {
        children.push(currentNode);
        currentNode = tree.nextNode();
    }
    // 判断子节点是不是全为 行内元素
    var allInnerNode = function (node) {
        if (node.children.length > 0) {
            return Array.from(node.children).every(function (el) {
                return window.getComputedStyle(el).display === 'inline'
                    || ['i', 'svg', 'strong', 'em'].includes(el.tagName.toLocaleLowerCase()); // 处理 flex 下 text 行内元素混排的情况
            });
        }
        return false;
    };
    // 选出需要的 node
    var selectNode = function (node) {
        if (node.children.length !== 0
            && !allInnerNode(node)
            && node.tagName.toLocaleLowerCase() !== 'button') {
            return false;
        }
        else if (skeepButton(node)) {
            return false;
        }
        return true;
    };
    return children.slice(0).filter(selectNode);
}
// addClass
var addClass = function (nodes) {
    nodes.forEach(function (element) {
        if (isTag(element, 'img')) {
            element.classList.add(MANHATTAN_SKELETON_IMG);
            return;
        }
        element.classList.add(availableClass);
    });
};
// removeClass
var removeClass = function (nodes) {
    nodes.forEach(function (element) {
        if (isTag(element, 'img')) {
            element.classList.remove(MANHATTAN_SKELETON_IMG);
            return;
        }
        element.classList.remove(availableClass);
    });
};
export var _vskeleton = {
    inserted: function (el, binding, vnode) {
        if (binding.value) {
            el.classList.add(MANHATTAN_SKELETON);
            var allChildren = getChildren(el);
            addClass(allChildren);
            selectImgNode(allChildren).forEach(function (img) {
                replaceImgToSvg(img);
            });
        }
    },
    componentUpdated: function (el, binding) {
        if (binding.value) {
            el.classList.add(MANHATTAN_SKELETON);
            var allChildren = getChildren(el);
            addClass(allChildren);
        }
        else {
            el.classList.remove(MANHATTAN_SKELETON);
            var allChildren = getChildren(el);
            removeClass(allChildren);
            selectImgNode(allChildren).forEach(function (img) {
                replaceSvgToImg(img);
            });
        }
    },
    unbind: function (el, binding) {
        el.classList.remove(MANHATTAN_SKELETON);
        var allChildren = getChildren(el);
        removeClass(allChildren);
        selectImgNode(allChildren).forEach(function (img) {
            replaceSvgToImg(img);
        });
    }
};
var install = function (Vue, options) {
    Vue.directive('skeleton', _vskeleton);
    if (options && options.img) {
        window._vskeleton_default_img = options.img;
    }
};
export default {
    _vskeleton: _vskeleton,
    install: install,
};
